import axios from 'axios';

const RESOURCE_NAME = '/registration';

export default {

    register(form, token) {
        return axios.post(`${RESOURCE_NAME}/register`, {'RegistrationForm': form, token: token})
    },

    confirm(activationCode) {
        return axios.post(`${RESOURCE_NAME}/confirm`, {activationCode})
    },

    checkInvite(hash) {
        return axios.get(`${RESOURCE_NAME}/check-invite?hash=${hash}`)
    }
}